import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={23}
    height={23}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.321 18.114v3.928a.786.786 0 0 1-.785.786H2.607A2.357 2.357 0 0 1 .25 20.471v-2.357a.786.786 0 0 1 .786-.786h5.5a.786.786 0 0 1 .785.786Zm14.143-.786H9.68a.786.786 0 0 0-.786.786v3.928a.786.786 0 0 0 .786.786h10.214a2.358 2.358 0 0 0 2.357-2.357v-2.357a.786.786 0 0 0-.786-.786Zm0-7.071H1.036a.786.786 0 0 0-.786.785v3.929a.786.786 0 0 0 .786.786h20.428a.786.786 0 0 0 .786-.786v-3.929a.786.786 0 0 0-.786-.785ZM19.893.828h-3.929a.786.786 0 0 0-.785.786V7.9a.786.786 0 0 0 .785.785h5.5a.786.786 0 0 0 .786-.785V3.185A2.357 2.357 0 0 0 19.893.828ZM1.036 8.685H12.82a.786.786 0 0 0 .786-.785V1.614a.786.786 0 0 0-.786-.786H2.607A2.358 2.358 0 0 0 .25 3.185V7.9a.786.786 0 0 0 .786.785Z"
      fill="var(--text-primary)"
    />
  </svg>
);

export default SvgComponent;
